import axios from "axios";
import { FULFILLED, PENDING, REJECTED } from "./action-type.util";

const ACTION_TYPES = {
  FETCH_MEMOS_LIST: "applications/FETCH_MEMOS_LIST",
  FETCH_MEMO_OPTIONS: "applications/FETCH_MEMO_OPTIONS",
  FETCH_MEMO_DETAILS: "applications/FETCH_MEMO_DETAILS",
  SUBMIT_MEMO: "applications/SUBMIT_MEMO",
};

const initialState = {
  loading: false,
  submitting: false,
  memosList: [],
  memoDetails: null,
};

export type ApplicationMemosState = Readonly<typeof initialState>;

/**
 * ApplicationMemos Reducer
 */
export default (state: ApplicationMemosState = initialState, action): ApplicationMemosState => {
  switch (action.type) {
    case PENDING(ACTION_TYPES.FETCH_MEMOS_LIST):
      return { ...state, loading: true };

    case FULFILLED(ACTION_TYPES.FETCH_MEMOS_LIST): {
      const memosList = action.payload.data?.items || [];
      return {
        ...state,
        loading: false,
        memosList,
      };
    }

    case REJECTED(ACTION_TYPES.FETCH_MEMO_OPTIONS):
      return { ...state, loading: false };

    case PENDING(ACTION_TYPES.FETCH_MEMO_OPTIONS):
      return { ...state, loading: true };

    case FULFILLED(ACTION_TYPES.FETCH_MEMO_OPTIONS): {
      const memoDetails = action.payload.data;
      return {
        ...state,
        loading: false,
        memoDetails,
      };
    }

    case REJECTED(ACTION_TYPES.FETCH_MEMOS_LIST):
      return { ...state, loading: false };

    case REJECTED(ACTION_TYPES.SUBMIT_MEMO):
      return { ...state, submitting: false };

    case PENDING(ACTION_TYPES.SUBMIT_MEMO):
      return { ...state, submitting: true };

    case FULFILLED(ACTION_TYPES.SUBMIT_MEMO): {
      return {
        ...state,
        submitting: false,
      };
    }

    default:
      return state;
  }
};

/**
 * Actions for fetching memos data
 */
export const fetchAppMemosList = ({ appId, page, rows, sort, query }) => ({
  type: ACTION_TYPES.FETCH_MEMOS_LIST,
  meta: { listOptions: { page, rows, sort, query } },
  payload: axios.get(`applications/${appId}/memos`, {
    params: { rows, page, sort, ...query },
  }),
});

export const fetchMemoOptions = (appId: string, memoType: string | null = null) => ({
  type: ACTION_TYPES.FETCH_MEMO_OPTIONS,
  payload: axios.get(`applications/${appId}/memos/new${memoType ? `?templateId=${memoType}` : ""}`),
});

export const fetchMemoDetails = (appId: string, memoId: string) => ({
  type: ACTION_TYPES.FETCH_MEMO_OPTIONS,
  payload: axios.get(`applications/${appId}/memos/new/${memoId}`),
});

export const saveMemo = (applicationId, payload: Record<string, any>, files: File[]) => {
  const formData = new FormData();
  for (let key in payload) {
    formData.append(key, payload[key] || "");
  }
  files.forEach(file => {
    formData.append("Attachments", file);
  });
  return {
    type: ACTION_TYPES.SUBMIT_MEMO,
    payload: axios.post(`/applications/${applicationId}/memos/sendMemo`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  };
};
